import styles from './forgot-pass.module.scss';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ClearServices from '../../../Assets/Images/Logos/ClearServices Logos/ClearServices.png';
import useInView from '../../../Components/UseInView/useInView';
import { handleError } from '../../../Services/api.service';
import Loader from '../../../Components/Loader/Loader';
import AuthService from '../../../Services/auth.service';
import InputField from '../../../Components/InputField/InputField';
import Button from '../../../Components/Button/Button';

const ForgotPass = () => {
    const [boxRef, boxVisible] = useInView();
    const navigate = useNavigate();
    const { uid, token } = useParams();
    const [loading, setLoading] = useState(true);
    const [password, setPassword] = useState('');

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 3000);
    // eslint-disable-next-line
    }, []);

    const resetPassword = async () => {
        setLoading(true);
        try {
            await AuthService.resetPass(uid, token, password);
        } catch (err) {
            handleError(err);
        } finally {
            setTimeout(() => {
                setLoading(false);
                navigate('/login');
            }, 3000);
        }
    }
    
    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>

            <div className={styles.container}>
                <div
                    id='Forgot Landing'
                    ref={boxRef}
                    className={`${styles.wrapper} ${boxVisible ? styles.visible : ''}`}
                >
                    <a href='/'>
                        <img src={ClearServices} alt='ClearServices' />
                    </a>
                    <div className={styles.card}>
                        {
                            loading ?
                                <>
                                    <Loader
                                        customStyle={{ marginTop: '0', marginBottom: '0' }}
                                    />
                                    <p>We are processing your request</p>
                                </>
                            :
                            <>
                                <InputField
                                    label='Password'
                                    path='lock.png'
                                    placeholder='Enter password'
                                    type='password'
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    maxLength='25'
                                />

                                <Button
                                    buttonText="Submit"
                                    displayIcon={true}
                                    onClick={resetPassword}
                                />
                            </>
                        }
                    </div>

                    <p className={styles.footerTag}>
                        © {new Date().getFullYear()} Clear Property Management
                    </p>
                </div>
            </div>
        </>
    );
};

export default ForgotPass;
